/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
function interpolateFn(message, parameters) {
    let index = 0;
    return message.replace(/{}/g, () => {
        index += 1;
        return parameters[index - 1];
    });
}
/**
 * Simple 'localize' pure function factory.
 */
export function init(bundle) {
    return (locale, message, ...parameters) => interpolateFn(bundle[locale][message], parameters);
}
//# sourceMappingURL=i18n.js.map